'use client';
import React, { useState, useEffect } from 'react';
import { CategoriesGrid as SharedCategoriesGrid } from '@launchstore/shared-puck';
import type { CategoriesGridProps, SharedCategory } from '@launchstore/shared-puck';

// Wrapper that fetches categories from storefront API and projects to shared's
// minimal SharedCategory shape. Original CategoriesGridClient.tsx logic inlined.
const SharedCategoriesGridRender = (SharedCategoriesGrid as any).render;

const CategoriesGridImpl: React.FC<CategoriesGridProps> = (props: any) => {
  const [categories, setCategories] = useState<SharedCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    async function fetchCategories() {
      setLoading(true); setError('');
      try {
        const countryCode = (typeof window !== 'undefined' ? window.location.pathname.split('/')[1] : '') || 'us';
        const res = await fetch(`/${countryCode}/api/categories`);
        const data = await res.json();
        const raw: any[] = data.product_categories || [];
        const projected: SharedCategory[] = raw.map((c: any) => ({
          id: c.id,
          name: c.name,
          handle: c.handle,
          image: c.thumbnail_url || undefined,
          productCount: c.product_count ?? c.products?.length ?? 0,
        }));
        setCategories(projected);
      } catch (err: any) {
        setError(err?.message || 'Failed to fetch categories');
      } finally {
        setLoading(false);
      }
    }
    fetchCategories();
  }, []);

  return <SharedCategoriesGridRender {...props} categories={categories} loading={loading} error={error} />;
};

export const CategoriesGrid: any = { ...SharedCategoriesGrid, render: (props: any) => <CategoriesGridImpl {...props} /> };
export default CategoriesGrid;
